import Vue from 'vue';
import { getValidationMessages } from './utils/validationMessages';
const format = require('date-fns/format');

const isValidDate = (date: any): boolean => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return date instanceof Date && !isNaN(date);
};
export interface DataLoopParams {
  [key: string]: any;
  limit: number | string;
}
/**
 * Получаем в рекурсии все данные от апи,
 * ну всм когда там пагинация и много данных
 * и нужно их все получить
 * @param   params - параметры объект, залетит в apiFn, обязательно должен быть {..., limit: n, ...}
 * @param   amountCountKey - имя ключа, в которм бек вернёт всего кол-во элем.
 * @param   apiFn - ваша функция, которая получает данные от бека. Должна обязательно уметь принимать
 * fn({... ,limit: n, page: n})
 * */
const getDataLoop = (
  params: DataLoopParams,
  amountCountKey: string,
  apiFn: Function
): Promise<Array<any>> => {
  let amountCount: string | any = null;
  let page = 1;
  let resArr: any = [];
  let pageLength: number | null = null;

  const getData = async () => {
    try {
      const { data } = await apiFn({
        ...params,
        page: page,
      });
      resArr = resArr.concat(data.data);
      if (!amountCount) {
        amountCount = data[amountCountKey];
        pageLength = Math.ceil(+amountCount / +params.limit);
      }
      page++;
    } catch (e) {
      console.error(e);
      page++;
    }
    if (pageLength && page <= pageLength) {
      await getData();
    }
    return resArr;
  };

  return new Promise((resolve) => {
    getData().then((r) => {
      resolve(r);
    });
  });
};
/** Обёртка, выбрасывает сообщения ошибок бека, что бы потом легко можно было выести в try - catch
 * вызов как анонимки
 * пример:
 *       await _util.errorAxiosHandler(async () => {
            const { data } = await _axiosInstance.post(
              'summerHolidayRequest/create',
              {
                data: {
                  children: this.children
                    .filter((el: any) => this.formData[1].selectedChild[el.id])
                    .map((el: any) => {
                      return el.id;
                    }),
                  camp_id: this.campData.camp.id,
                  gang_id: this.selectedGang.options.value,
                },
              }
            );
            return data;
      });
 *
 * */
const errorAxiosHandler = async (fn: Function) => {
  return await fn().catch(({ response }: any) => {
    if (!response) throw 'сервер не отвечает';
    if (response) {
      throw response.data.errors ? response.data.errors : response.data.message;
    }
  });
};
/** Делаем Первую буквку в строке Заглавной*/
const capitalizeByFirst = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
/** Перевод dd.mm.yyyy в yyyy-mm-dd для бека*/
const dateConvertRusViewFormatToApiFormat = (strDate: string) => {
  const pattern = new RegExp(/^(\d{1,2}).(\d{1,2}).(\d{4})$/);
  const dt = new Date(strDate.replace(pattern, '$3-$2-$1'));
  if (pattern.test(strDate) && isValidDate(dt)) {
    return format(dt, 'YYYY-MM-DD');
  } else {
    throw `bad format dateConvertRusViewFormatToApiFormat(). strDate: ${strDate}`;
  }
};

/** Перевод yyyy-mm-dd in dd.mm.yyyy для фронта */
const dateConvertApiFormatToRusViewFormat = (strDate: string) => {
  const dt = strDate.substr(0, 10);
  const pattern = new RegExp(/^\d{4}-\d{2}-\d{2}$/);
  if (pattern.test(dt)) {
    const dArr = dt.split('-'); // ex input "2010-01-18"
    return dArr[2] + '.' + dArr[1] + '.' + dArr[0]; //ex out: "31.12.2007"
  } else {
    throw `bad format dateConvertRusViewFormatToApiFormat(). strDate: ${strDate}`;
  }
};

/** сообщения валидации,
 * @param validStateData - объект с валдиации.
 * @param maskExample - если маска, то что выводить в сообщении пример значения (не обяз.) */
const validationMessage = (validStateData: any, maskExample?: string) => {
  try {
    return getValidationMessages(validStateData, maskExample);
  } catch (e) {
    return null;
  }
};

/** Вернёт разрешённый на текущем регионе роут метода авторизации для попап окна обычный вход или через другие сервисы
 * @param modulesStore - массив стора с модулями "apiModules"
 * */
const getRouteHashAllowAuthMethod = (apiModules: []): string => {
  const isNotModuleClientAuth = !apiModules.some(
    (el: any) => el.alias === 'clientAuth'
  );
  // на случай если вообще модуль не существует
  if (isNotModuleClientAuth) {
    return '#entrance';
  }
  const isAllowBaseLogIn = apiModules.some(
    (el: any) => el.alias === 'clientAuth' && el.is_allow_base_login
  );
  const isAllowExternalAuthServices = apiModules.some(
    (el: any) => el.alias === 'esia'
  );
  return isAllowBaseLogIn
    ? '#entrance'
    : isAllowExternalAuthServices
    ? '#auth-services'
    : '';
};

/** проверить выходит ли дата за даипозон дат мин. макс.
 * @param val строка даты
 * @param min мин. значение YYYY-MM-DD
 * @param max макс. значение YYYY-MM-DD
 * @param format формат строки входящей даты YYYY-MM-DD или DD.MM.YYYY (капсом)
 * */
const checkIsOutOfRangeDate = (
  val: string,
  min: string,
  max: string,
  format: string
) => {
  let dateCheck: any = null;
  try {
    if (format !== 'DD.MM.YYYY' && format !== 'YYYY-MM-DD') return false;
    // TODO: я поправил валидацию дат, но в последствии надо переписать всё на валидационных хелперах из
    // tools/validations с динамическим выводом сообщений которые можно кастомно расположить в самом компоненте
    // p.s. нужно создать дикшенарь всех дефолтных сообщений и выводить их если в тз не указано обратное
    const [day, month, year] =
      format === 'DD.MM.YYYY'
        ? val.split('.').map(Number)
        : val.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() + 1 !== month ||
      date.getDate() !== day
    ) {
      return false;
    }

    const validRusFormat = RegExp(
      `^\\s*(3[01]|[12][0-9]|0?[1-9])\\.(1[012]|0?[1-9])\\.((?:19|20)\\d{2})\\s*$`
    ).test(val);
    const validSrvFormat = RegExp(
      `([12]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01]))`
    ).test(val);
    if (!validRusFormat && !validSrvFormat) return false;
    if (format === 'DD.MM.YYYY')
      dateCheck = dateConvertRusViewFormatToApiFormat(val);
    if (format === 'YYYY-MM-DD') dateCheck = val;
    return dateCheck >= min && dateCheck <= max;
  } catch (e) {
    console.error('ошибка сравнения дат');
    return false;
  }
};

/** Получить дату первого дня недели от переданной даты **/
const getFirstDayOfWeekByDate = (currentDate: Date) => {
  return new Date(
    currentDate.setDate(
      currentDate.getDate() -
        currentDate.getDay() +
        (currentDate.getDay() == 0 ? -6 : 1)
    )
  );
};

/** Получить дату последнего дня недели от переданной даты **/
const getLastDayOfWeekByDate = (currentDate: Date) => {
  return new Date(
    currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 7)
  );
};

/** глобальные уттилиты / разные свои хелперы */
export const utilList = {
  errorAxiosHandler,
  capitalizeByFirst,
  dateConvertRusViewFormatToApiFormat,
  validationMessage,
  checkIsOutOfRangeDate,
  getRouteHashAllowAuthMethod,
  dateConvertApiFormatToRusViewFormat,
  getDataLoop,
  getFirstDayOfWeekByDate,
  getLastDayOfWeekByDate,
};
export const _util: typeof utilList = utilList; // для TS
Vue.prototype.$util = utilList; // для Vue



// WEBPACK FOOTER //
// ./src/tools/declare/global/$util.ts